import { API } from 'src/api/API';

export const useReadSetpointsOnIntegration = (objectId: number) => {
    const revalidate = async () => {
        return new API().readSetpointsOnIntegration(objectId);
    };

    return { revalidate } as const;
};
